const getSafeRedirectUrl = url => {
  if (typeof url !== 'string' || !url.trim()) {
    return '/';
  }
  try {
    const parsedUrl = new URL(url, window.location.origin);
    const isSameOrigin = parsedUrl.origin === window.location.origin;
    const isHttpProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    if (!isSameOrigin || !isHttpProtocol) {
      return '/';
    }
    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch (e) {
    return '/';
  }
};
export const redirectTo = url => {
  const safeUrl = getSafeRedirectUrl(url);
  window.history.replaceState(null, null, safeUrl);
  window.location.href = safeUrl;
};